import { render, staticRenderFns } from "./tabCollectionIndex.vue?vue&type=template&id=5e1c2cd8"
import script from "./tabCollectionIndex.vue?vue&type=script&lang=js"
export * from "./tabCollectionIndex.vue?vue&type=script&lang=js"
import style0 from "./tabCollectionIndex.vue?vue&type=style&index=0&id=5e1c2cd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports